"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const CalendarGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "CALENDAR-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.368-.002a.5.5 0 0 1 .492.41l.008.09v2.567h4.134a2 2 0 0 1 1.994 1.851l.006.15v16.936a2 2 0 0 1-2 2H1.998a2 2 0 0 1-2-2V5.065a2 2 0 0 1 2-2h4.134V.498a.5.5 0 0 1 .992-.09l.008.09v2.567h9.735V.498a.5.5 0 0 1 .5-.5M23 10.2H.998v11.803a1 1 0 0 0 .883.993l.117.007h20.004a1 1 0 0 0 1-1V10.199M6.132 4.065H1.998a1 1 0 0 0-1 1V9.2h22.003V5.065a1 1 0 0 0-.882-.993l-.117-.007h-4.135v1.8a.5.5 0 0 1-.991.09l-.008-.09v-1.8H7.131v1.8a.5.5 0 0 1-.992.09l-.008-.09v-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.482 18.401.111.007a.884.884 0 1 1-.222 0l.111-.007m6.518 0 .11.007a.884.884 0 1 1-.22 0l.11-.007m6.518 0 .11.007a.884.884 0 1 1-.221 0l.11-.007M5.482 13.034l.111.006a.884.884 0 1 1-.222 0l.111-.006Zm6.518 0 .11.006a.884.884 0 1 1-.22 0l.11-.006m6.518 0 .11.006a.884.884 0 1 1-.221 0l.11-.006"
  })));
};
CalendarGraphicIcon.displayName = "CalendarGraphicIcon";
CalendarGraphicIcon.iconName = "Calendar";
export default CalendarGraphicIcon;